import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FooterComponent } from "app/bundles/layouts/footer/footer.component";
import { TranslateModule } from "@ngx-translate/core";

@NgModule({
  imports: [CommonModule, TranslateModule.forChild()],
  declarations: [FooterComponent],
  exports: [FooterComponent],
})
export class LayoutModule {}
